import appConfig from '@nerdwallet/app-config';
import getNwApiSdk from '@nerdwallet/nw-api-sdk';

const nwApiSdk = getNwApiSdk({
  clientID: appConfig.CLIENT_ID,
  applicationID: appConfig.APPLICATION_ID,
});

const { httpClient } = nwApiSdk;

export { httpClient };
export default nwApiSdk;
